module.exports = __webpack_public_path__ + "img/shawnee-green.39cd4f83.jpg";